import { deleteFace } from './deleteFace';

interface DeleteFaceHandlerProps {
  faceId: string;
  onSuccess?: VoidFunction;
}

export const deleteFaceHandler = ({
  faceId, onSuccess = undefined,
}: DeleteFaceHandlerProps) => (e?: React.MouseEvent<HTMLElement>): void => {
  e?.stopPropagation();
  deleteFace({ faceId, onSuccess });
};
